module.exports = (() => {
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_STAGING ? {
      apiHost: 'http://111.223.53.79:3000',
      cloudAPIHost: 'https://asia-east2-o-plus-staging.cloudfunctions.net/api'
    } : {
      apiHost: 'https://api.oplus-school.com',
      cloudAPIHost: 'https://asia-east2-o-plus-22e7f.cloudfunctions.net/api'
    }
  }

  // Default config
  return {
    apiHost: 'http://111.223.53.79:3000',
    cloudAPIHost: 'https://asia-east2-o-plus-staging.cloudfunctions.net/api'
  }
})()



// WEBPACK FOOTER //
// ./src/config.js